import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Form from 'Components/Form'
import Input from 'Components/Input'
import Search from 'Components/Search'
import ApiRequest from 'EurestoApi/ApiRequest'
import Data from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import DataComponent from 'EurestoComponents/DataComponents'
import Recherche from 'EurestoComponents/Recherche'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'




export default class extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      action: 'view',
      FiltreComponent: undefined,
      search: {},
      filtre_libelle: '',
      filtre_public: 0,
      key: Utils.getRandomNumber()
    }
  }

  onChangeFiltre = (data, name) => {
    this.setState({
      search: {
        ...this.state.search,
        [name]: data
      }
    })
  }

  onChangeFiltreLibelle = (data, name) => {
    this.setState({
      [name]: data
    })
  }

  async componentDidMount () {
    this.setState({
      FiltreComponent: (await import(`./${this.props.module}/${this.props.donnee}`)).default
    })
  }

  formFiltre = (disabled, autofocus) => {
    return (
      <Grid container style={{
        height: User.CalculHeight.getHeightWanted(70),
        maxHeight: User.CalculHeight.getHeightWanted(70),
        margin: 0, padding: 0
      }} spacing={0} justify={'flex-start'} alignItems={'flex-start'} direction={'column'}>
        <Grid item style={{ margin: 0, padding: 0 }}>
          <Grid container style={{ padding: 0, margin: 0 }} spacing={0}>
            <Grid item style={{ margin: 0, padding: 0 }}>
            {this.state.action === 'view' && <DataComponent
              title={EurestoI18n.t('crm:Filtre')}
              name="filtre"
              type={Constants.typeSaisie.ComboSimple}
              onChange={this.onView}

              data={this.state.filtre}
              object={Constants.donnee.filtre}
              module={Constants.module.PRIVEE}
              search={{ module: this.props.module, donnee: this.props.donnee }}
            /> ||
            <Input autoFocus={autofocus} value={this.state.filtre_libelle} title={'Nom'} name={'filtre_libelle'}
                   onChange={this.onChangeFiltreLibelle}/>
            }
            </Grid>

            <Grid item style={{ margin: 0, padding: 0 }}>
              <i style={{ paddingBottom: 7 }}
                 className={(!disabled && 'cursor-pointer' || '') + ' fa-2x ei-crm_public ' + (this.state.filtre_public && 'EurestoSecondary--text')}
                 onClick={() => !disabled && this.onChangeFiltreLibelle(!this.state.filtre_public, 'filtre_public')}
              />
            </Grid>
          </Grid>
          <Search style={{ fontSize: 12, padding: 5, right: 0, position: 'absolute', top: -75 }}
                  background={'transparent'}
                  defaultSearchPriority
                  limit={100} defaultSearch={this.state.search}
                  requete={this.props.donnee}
                  search={this.props.name + '_gestion'}
                  path={this.props.module}>
            {this.state.FiltreComponent &&
            <this.state.FiltreComponent disabled={disabled} search={this.state.search} onChange={this.onChangeFiltre}/>}
          </Search>
        </Grid>
      </Grid>
    )
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'filtre',
      action: action,
      donnee: this.props.donnee,
      module: this.props.module,
      json: this.state.search,
      libelle: this.state.filtre_libelle,
      public: this.state.filtre_public,
      id: this.state.filtre
    })

    if (result) {
      this.onView(result.id)
    }
  }

  onCancel = () => {
    this.setState({
      action: 'add',
      filtre_libelle: '',
      filtre: undefined,
      filtre_public: 0,
      search: {},
      key: Utils.getRandomNumber()
    })
  }

  onUpdate = () => {
    this.setState({
      action: 'update',
      filtre_libelle: this.state.filtre && Data.get(Constants.module.PRIVEE, Constants.donnee.filtre, { id: this.state.filtre }).libelle || '',
      filtre_public: this.state.filtre && Data.get(Constants.module.PRIVEE, Constants.donnee.filtre, { id: this.state.filtre }).public || 0,
      key: Utils.getRandomNumber()
    })
  }

  onDelete = async () => {
    const result = await ApiRequest(project.api + 'commun', {
      requete: 'filtre',
      action: 'delete',
      id: this.state.filtre
    })

    if (result) {
      this.onView()
    }
  }

  onArchive = () => {
    console.log('not done yet')
  }

  onView = async (id, name, e) => {
    if(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const filtre = Data.list(Constants.module.PRIVEE, Constants.donnee.filtre, { id: id })
      || Data.list(Constants.module.PRIVEE, Constants.donnee.filtre, {
        module: this.props.module,
        donnee: this.props.donnee
      })

    if (filtre && filtre.length > 0) {
      this.setState({
        action: 'view',
        filtre: id,
        search: JSON.parse(filtre[0].json),
        key: Utils.getRandomNumber()
      })
    } else {
      this.setState({
        action: 'view',
        filtre: undefined,
        search: {},
        key: Utils.getRandomNumber()
      })
    }

  }

  render () {
    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
        <Grid item xs={8} style={{ margin: 0, padding: 10 }}>
          <Form showTab={false}
                onClickUpdate={false}
                action={this.state.action}
                key={this.state.key}
                isAllow={{
                  add: true,
                  update: this.state.filtre && Data.list(Constants.module.PRIVEE, Constants.donnee.filtre, {
                    module: this.props.module,
                    donnee: this.props.donnee
                  }).length > 0,
                  delete: this.state.filtre && Data.list(Constants.module.PRIVEE, Constants.donnee.filtre, {
                    module: this.props.module,
                    donnee: this.props.donnee
                  }).length > 0
                }}
                onUpdate={this.onUpdate}
                onSave={this.onSave}
                onCancel={this.onCancel}
                onDelete={this.onDelete}
                onArchive={this.onArchive}
                onView={this.onView}
                libelleAdd={EurestoI18n.t('commun:Nouveau filtre')}
                children={this.formFiltre}/>
          )
        </Grid>
        <Grid item xs={4} style={{ margin: 0, padding: 10 }}>
          <Paper style={{
            height: User.CalculHeight.getHeightWanted(70),
            maxHeight: User.CalculHeight.getHeightWanted(70),
            marginTop: 35
          }}>
            <Recherche
              view={'list'}
              type={this.props.type}
              style={{
                maxHeight: User.CalculHeight.getHeightWanted(85),
              }}
              onClick={() => null}
              columns={[
                { Header: 'id', accessor: 'id', show: false }, {
                  Header:
                    <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-start'}
                          alignItems={'center'}>
                      <b>Personne/Entité</b>
                    </Grid>,
                  accessor: 'libelle',
                  minWidth: 130,
                  Cell: row => {
                    let libelleCivilite = ''
                    if (row.original.civilite_id !== undefined && row.original.civilite_id !== null && row.original.entite === 1) {
                      const civiliteFound = Data.get(Constants.module.COMMUN, Constants.donnee.civilite, { id: row.original.civilite_id })
                      libelleCivilite = civiliteFound.abrege
                    }
                    return (
                      <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }}
                            justify={'flex-start'}
                            alignItems={'center'}>
                        <b>{(libelleCivilite && (libelleCivilite + ' ')) + row.original.libelle}</b>
                      </Grid>
                    )
                  },
                },]}
              search={this.props.name + '_gestion'}
            />
          </Paper>
        </Grid>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Filtre/Gestion.js